import { gql } from "@apollo/client";

export const getDowntimeMethodCapture = gql`
    query getDowntimeMethodCapture {
        downtime_method_capture {
            downtime_method_capture_id
            name
        }
    }
`;
